import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class BIONOL100 extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">BIONOL 100</h1>
        </header>

        {/* English Section */}
        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.3649 (E) Dated 13-08-2025</li>
            <li><span className="label">2. Title of Biostimulant:</span> (27) Protein Hydrolysate (Plant Source) (Powder)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Protein Hydrolysates derived through Acid hydrolysis (Hydrochloric acid) of Glycine max beans per cent. by weight, minimum: 25</li>
                <li>(ii) Bentonite per cent. by weight: QS</li>
                <li>(iii) Total (per cent): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. Crop:</span> Chilli</li>
            <li><span className="label">5. Doses:</span>
              <ul>
                <li>Chilli: Four foliar applications at 120 g/ha</li>
               
              </ul>
            </li>
          </ul>
        </div>

        {/* Hindi Section */}
        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.3649 (ई) दिनांक 13-08-2025</li>
            <li><span className="label">2. जैवउत्तेजक का शीर्षक:</span> (27) प्रोटीन हाइड्रोलाइज़ेट (पौधे स्रोत) (पाउडर)</li>
            <li><span className="label">3. संरचना:</span>
              <ul>
                <li>(i) ग्लाइसिन अधिकतम बीन्स के अम्ल हाइड्रोलिसिस (हाइड्रोक्लोरिक अम्ल) द्वारा प्राप्त प्रोटीन हाइड्रोलाइज़ेट, भार के अनुसार प्रतिशत, न्यूनतम: 25</li>
                <li>(ii) बेंटोनाइट भार के अनुसार प्रतिशत: क्यूएस</li>
                <li>(iii) कुल (प्रतिशत): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> मिर्च</li>
            <li><span className="label">5. मात्रा:</span>
              <ul>
                <li>मिर्च: 120 ग्राम/हेक्टेयर की दर से चार पर्णीय छिड़काव</li>
                
              </ul>
            </li>
          </ul>
        </div>

        {/* Marathi Section */}
        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> एस.ओ.३६४९ (ई) दिनांक १३-०८-२०२५</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (२७) प्रथिने हायड्रोलायझेट (वनस्पती स्रोत) (पावडर)</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(i) ग्लायसीनच्या आम्ल जलविच्छेदन (हायड्रोक्लोरिक आम्ल) द्वारे मिळवलेले प्रथिने हायड्रोलायझेट जास्तीत जास्त बीन्स टक्के. वजनाने, किमान: २५</li>
                <li>(ii) बेंटोनाइट टक्के. वजनाने: QS</li>
                <li>(iii) एकूण (टक्के): १००.०</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> मिरची</li>
            <li><span className="label">५. मात्रा:</span>
              <ul>
                <li>मिरची: १२० ग्रॅम/हेक्टर दराने पानांवरील चार अनुप्रयोग</li>
                
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
